import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
import { usePricing } from '../contexts/PricingContext';
export const PricingCards = () => {
  const {
    selectedOption,
    setSelectedOption
  } = usePricing();
  const options = {
    standard: {
      icon: '📘',
      title: 'PILATES 360',
      subtitle: '6 Tomos + 6 Bonos',
      oldPrice: '$34.990',
      price: '$19.990',
      cta: '→ QUIERO MI PILATES 360 AHORA'
    },
    premium: {
      icon: '🏆',
      title: 'PILATES 360 + SAFE PILATES PRO™',
      subtitle: '6 Tomos + 6 Bonos + Safe Pilates Pro™',
      description: '(Guía completa de adaptaciones para 18 patologías + checklist de seguridad + protocolo de emergencia)',
      oldPrice: '$43.990',
      price: '$27.990',
      savings: 'AHORRÁS $16.000',
      badge: 'MÁS ELEGIDO',
      cta: '→ SÍ, QUIERO EL PILATES 360 + SAFE PILATES PRO'
    }
  };
  return <section id="pricing" className="py-8 md:py-16 bg-charcoal" data-id="element-197">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        <div className="text-center mb-5 md:mb-10" data-id="element-199">
          <h2 className="text-xl md:text-4xl font-bold text-white font-playfair mb-2" data-id="element-200">
            Elegí tu{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sage-400 to-gold" data-id="element-201">
              Pilates 360:
            </span>
          </h2>
          <p className="text-sm md:text-lg text-gray-300" data-id="element-202">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="space-y-3 mb-4 md:mb-6" data-id="element-203">
          {/* Standard Option */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelectedOption('standard')} className={`relative bg-white/5 backdrop-blur-sm rounded-xl md:rounded-2xl p-4 md:p-6 cursor-pointer transition-all ${selectedOption === 'standard' ? 'border-2 border-sage-500' : 'border-2 border-transparent hover:border-white/20'}`} data-id="element-204">
            <div className="flex items-center gap-3 md:gap-4" data-id="element-205">
              {/* Radio Button */}
              <div className="flex-shrink-0" data-id="element-206">
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-all ${selectedOption === 'standard' ? 'border-sage-500 bg-sage-500' : 'border-gray-400'}`} data-id="element-207">
                  {selectedOption === 'standard' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-white rounded-full" data-id="element-208"></div>}
                </div>
              </div>

              {/* Content */}
              <div className="flex-grow flex items-center justify-between gap-2" data-id="element-209">
                <div data-id="element-210">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-211">
                    <span className="text-lg md:text-2xl" data-id="element-212">
                      {options.standard.icon}
                    </span>
                    <h3 className="text-sm md:text-xl font-bold text-white" data-id="element-213">
                      {options.standard.title}
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-gray-400" data-id="element-214">
                    {options.standard.subtitle}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-215">
                  <div className="text-[10px] md:text-sm text-gray-500 line-through" data-id="element-216">
                    {options.standard.oldPrice}
                  </div>
                  <div className="text-xl md:text-3xl font-bold text-white" data-id="element-217">
                    {options.standard.price}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Premium Option */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelectedOption('premium')} className={`relative bg-white/5 backdrop-blur-sm rounded-xl md:rounded-2xl p-4 md:p-6 cursor-pointer transition-all ${selectedOption === 'premium' ? 'border-2 border-sage-500' : 'border-2 border-transparent hover:border-white/20'}`} data-id="element-218">
            {/* Badges */}
            <div className="absolute -top-2.5 left-4 md:left-6 flex gap-1.5 md:gap-2" data-id="element-219">
              <span className="bg-gold text-sage-900 px-2 md:px-3 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs font-bold flex items-center gap-1" data-id="element-220">
                🔥 {options.premium.badge}
              </span>
              <span className="bg-sage-600 text-white px-2 md:px-3 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs font-bold" data-id="element-221">
                {options.premium.savings}
              </span>
            </div>

            <div className="flex items-center gap-3 md:gap-4 mt-1 md:mt-2" data-id="element-222">
              {/* Radio Button */}
              <div className="flex-shrink-0" data-id="element-223">
                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-all ${selectedOption === 'premium' ? 'border-sage-500 bg-sage-500' : 'border-gray-400'}`} data-id="element-224">
                  {selectedOption === 'premium' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-white rounded-full" data-id="element-225"></div>}
                </div>
              </div>

              {/* Content */}
              <div className="flex-grow flex items-start justify-between gap-2" data-id="element-226">
                <div className="min-w-0" data-id="element-227">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-228">
                    <span className="text-lg md:text-2xl" data-id="element-229">
                      {options.premium.icon}
                    </span>
                    <h3 className="text-sm md:text-xl font-bold text-white leading-tight" data-id="element-230">
                      {options.premium.title}
                    </h3>
                  </div>
                  <p className="text-xs md:text-sm text-gray-400 mb-1" data-id="element-231">
                    {options.premium.subtitle}
                  </p>
                  <p className="text-[10px] md:text-xs text-gray-500 italic leading-tight" data-id="element-232">
                    {options.premium.description}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-233">
                  <div className="text-[10px] md:text-sm text-gray-500 line-through" data-id="element-234">
                    {options.premium.oldPrice}
                  </div>
                  <div className="text-xl md:text-3xl font-bold text-gold" data-id="element-235">
                    {options.premium.price}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* CTA Button */}
        <motion.a href={selectedOption === 'standard' ? 'https://checkout.rincondigital.shop/cart/54020862804243:1' : 'https://checkout.rincondigital.shop/cart/54020862935315:1'} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="block w-full text-center px-4 py-3 md:px-6 md:py-4 bg-sage-600 hover:bg-sage-700 text-white font-bold text-sm md:text-lg rounded-xl transition-all shadow-lg hover:shadow-xl mb-3" data-id="element-236">
          {selectedOption === 'standard' ? options.standard.cta : options.premium.cta}
        </motion.a>

        {/* Subtitle */}
        <p className="text-[10px] md:text-sm text-center text-gray-400 italic mb-5 md:mb-8 px-2" data-id="element-237">
          La más elegida por instructoras que quieren enseñar con seguridad
          total y verse como las profesionales que realmente son
        </p>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-238">
          <div className="flex items-center gap-1.5" data-id="element-239">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-sage-400" data-id="element-240" />
            <span data-id="element-241">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-242">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold" data-id="element-243" />
            <span data-id="element-244">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-245">
            <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-sage-400" data-id="element-246" />
            <span data-id="element-247">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-248">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 text-sage-400" data-id="element-249" />
            <span data-id="element-250">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
};